import { styled } from '@abyss/web/tools/styled';
export const ProgressBarContainer = styled('div', {
  width: '100%',
  height: '14px',
  overflow: 'hidden',
  border:
    '$borderWidths$progress-bar.border-width.root solid $progress-bar.color.border.root',
  borderRadius: '$progress-bar.border-radius.root',
});
export const ProgressBarFill = styled('div', {
  static: {
    height: '$progress-bar.size.height.root',
    display: 'flex',
    justifyContent: 'end',
    alignItems: 'center',
  },
  dynamic: ({ cssProps }) => {
    const { progress, fillColor } = cssProps;
    return {
      width: `${progress || 0}%`,
      backgroundColor: fillColor || '$secondary2',
    };
  },
});
